"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTokenValid = isTokenValid;
var _decodeToken = require("./decodeToken");
function isTokenValid(token) {
  const tokenPayload = (0, _decodeToken.decodeToken)(token);
  if (!tokenPayload) {
    return false;
  }
  const {
    exp
  } = tokenPayload;
  const expirationDate = new Date(exp * 1000);
  return expirationDate >= new Date();
}
